module.exports = __webpack_public_path__ + "static/img/8.4969333.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/8.png
// module id = iJE7
// module chunks = 0